import { DrawerConstants } from "constants/constants";
import { Dispatch } from "redux";

export const openDrawer = (data: string) => (dispatch: Dispatch) => {
  dispatch({
    type: DrawerConstants.OPEN_DRAWER,
    payload: data,
  });
};

export const closeDrawer = () => (dispatch: Dispatch) => {
  dispatch({
    type: DrawerConstants.CLOSE_DRAWER,
  });
};
